<template>
  <base-table
    title="Inductions"
    titleSingle="Induction"
    :headers="headers"
    :items="tests"
    :valid="valid"
    :loading="loading"
    add
    @get-items="getTests"
    @put-item="putTests"
    @post-item="postTests"
    @edit-item="editTests"
    @view-item="viewTest"
    @delete-item="deleteTests"
    @modal-open="getLocations"
    @modal-close="resetForm"
  >
    <v-form ref="form" v-model="valid">
      <v-text-field
        v-model="test.name"
        :rules="[v => !!v || 'Name is required']"
        label="Name"
        required
      ></v-text-field>
      <v-text-field
        v-model="test.passingScore"
        :rules="[v => !!v || 'Passing Score is required']"
        label="Passing score"
        type="number"
        required
      ></v-text-field>
    </v-form>
  </base-table>
</template>

<script>
import TestService from "@/services/TestService.js";
import BaseTable from "@/components/tables/BaseTable.vue";

export default {
  name: "TestTable",
  components: {
    BaseTable
  },
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Passing Score", value: "passingScore" },
        { text: "Actions", value: "actionOverview" }
      ],
      tests: [],
      test: {
        testId: "",
        name: "",
        passingScore: ""
      },
      valid: true,
      loading: true
    };
  },
  methods: {
    getTests() {
      this.loading = true;
      TestService.getTests()
        .then(response => {
          this.tests = response;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    putTests() {
      if (this.$refs.form.validate()) {
        TestService.putTest(this.test).then(() => {
          this.getTests(), this.$snackbarSuccess("Test Successfully Added");
        });
      }
    },
    postTests() {
      if (this.$refs.form.validate()) {
        TestService.postTest(this.test).then(() => {
          this.getTests(), this.$snackbarSuccess("Test Successfully Added");
        });
      }
    },
    editTests(item) {
      this.test = Object.assign({}, item);
    },
    viewTest(item) {
      this.$router.push({
        name: "testDetails",
        params: { testId: item.testId }
      });
    },
    deleteTests(item) {
      TestService.deleteTest(item.testId).then(() => {
        this.getTests(), this.$snackbarSuccess("Test Deleted");
      });
    },
    resetForm() {
      // Doesn't clear everything since an edit pulls in extra fields
      // Does that matter?
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped></style>
